import { getUUID } from 'gyl-common/utils/uuid'

// 创建队列
export const createQueue = (config: any) => {
    const uid = getUUID()
    const unProcessQueue: any = []
    const processingQueue: any = []
    const statusMap: any = new Map()
    let cacheFiles: any = []

    const { key, processLimit, onStart, onProcess, onStop, onCancel, onFinish } = config

    const _next = (doneData: any) => {
        const index = processingQueue.findIndex((v: any) => v[key] === doneData[key])

        processingQueue.splice(index, 1)
        statusMap.delete(doneData[key])

        const isDone = unProcessQueue.length <= 0 && processingQueue.length <= 0

        if(isDone){
            onFinish && onFinish()
        }

        start()
    }

    const _exec = (target: any) => {
        onProcess && onProcess(target, _next.bind(null, target))
    }

    // 开始
    const start = () => {
        // 不存在未处理的文件
        if(unProcessQueue.length <= 0){
            return
        }

        // 满员
        if(processingQueue.length >= processLimit){
            return
        }

        onStart && onStart()

        const freeNum = processLimit - processingQueue.length
        const processData = unProcessQueue.slice(0, freeNum)

        unProcessQueue.splice(0, freeNum)
        processingQueue.push(...processData)

        processData.forEach((v: any) => {
            if(statusMap.has(v[key])){
                return
            }

            statusMap.set(v[key], v)

            _exec(v)
        })
    }

    // 暂停
    const stop = () => {
        unProcessQueue.unshift(...processingQueue)
        processingQueue.forEach(v => {
            statusMap.delete(v[key])
        })
        processingQueue.length = 0

        onStop && onStop()
    }

    // 取消
    const cancel = () => {
        unProcessQueue.length = 0
        processingQueue.length = 0

        unProcessQueue.push(...cacheFiles)

        onCancel && onCancel()
    }

    // 推送
    const push = (data: any) => {
        const files = Array.isArray(data) ? data : [data]

        cacheFiles = files

        unProcessQueue.push(...files)

        start()
    }

    return {
        uid,
        start,
        stop,
        cancel,
        push,
    }
}
